import { render } from "./SecondFooter.vue?vue&type=template&id=69643006&scoped=true&ts=true"
import script from "./SecondFooter.vue?vue&type=script&lang=ts"
export * from "./SecondFooter.vue?vue&type=script&lang=ts"

import "./SecondFooter.vue?vue&type=style&index=0&id=69643006&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69643006"]])

export default __exports__